import classNames from "classnames/bind";
import { AdContainerProps } from "./interface";
import classes from "./adContainer.module.scss";

const AdContainer = ({
    children,
    type,
    adContainerClasses,
}: AdContainerProps) => {
    const cx = classNames.bind(classes);
    const cssClasses = cx("adContainer", type, adContainerClasses);

    return <div className={cssClasses}>{children}</div>;
};

export default AdContainer;
